import { CircleCheck, CircleAlert } from "lucide-react";

interface TimeCardProps {
  label: string;
  time: string;
  manualTime?: string | null;
  approvedBy?: number | null;
}

export function TimeCard({ label, time, manualTime, approvedBy }: TimeCardProps) {
  const showBadge = manualTime && time !== "--:--";
  const isApproved = !!approvedBy;

  return (
    <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/20">
      <p className="text-xs text-white mb-1">{label}</p>
      <p className="text-xl font-bold text-white">
        {time || "--:--"}
      </p>
      {showBadge && (
        <>
          {isApproved ? (
            <div className="flex items-center gap-1 mt-1">
              <CircleCheck className="h-3 w-3 text-emerald-300" />
              <span className="text-[10px] text-blue-100">Approved</span>
            </div>
          ) : (
            <div className="flex items-center gap-1 mt-1">
              <CircleAlert className="h-3 w-3 text-orange-300" />
              <span className="text-[10px] text-orange-100">Pending</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}

